import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { DEFAULT_RELEVANCE_SCORE_FILTER_VALUE } from '../../../constants/relevance';
import {
  HotjarFilterOptionNotWatched,
  HotjarFilterOptionAll,
  HotjarFilterOptionWatched,
} from '../../../store/list/types';

import type { Store, HotjarFilters } from '../../../store/list/types';

/**
 * Get Filters preferences from localstorage
 */
export const getHotjarFiltersPreferences = (store: Store): void => {
  const { setHotjarFilters } = store.getState();

  const watchedFilterValues = [
    HotjarFilterOptionAll,
    HotjarFilterOptionWatched,
    HotjarFilterOptionNotWatched,
  ];
  const filterPreferences = LocalStorage.get('hotjarFiltersPreferences') as
    | HotjarFilters
    | undefined;

  if (!filterPreferences) {
    return;
  }

  // ensure we have a correct value for filters
  if (!watchedFilterValues.includes(filterPreferences.watched)) {
    filterPreferences.watched = HotjarFilterOptionAll;
  }

  if (
    !filterPreferences.relevanceScore ||
    !filterPreferences.relevanceScore.every((check) =>
      DEFAULT_RELEVANCE_SCORE_FILTER_VALUE.includes(check),
    )
  ) {
    filterPreferences.relevanceScore = [...DEFAULT_RELEVANCE_SCORE_FILTER_VALUE];
  }

  setHotjarFilters(filterPreferences);
};
